let reorderModalModule = null;

export const loadReorderModal = async () => {
  if (!reorderModalModule) {
    const module = await import(
      /* webpackChunkName: "made-reorder-modal" */
      "components/jiffy/made-reorder-modal/made-reorder-modal"
    );
    reorderModalModule = module.default;
  }
  return reorderModalModule;
};

let reactReorderModalModule = null;

export const loadReactReorderModal = async () => {
  if (!reactReorderModalModule) {
    const module = await import(
      /* webpackChunkName: "react-made-reorder-modal" */
      "components/jiffy/react-made-reorder-modal/made-reorder-modal"
    );
    reactReorderModalModule = module.initMadeReorder;
  }
  return reactReorderModalModule;
};

export const loadReviews = async () => {
  if (!document.querySelector(".js-jiffymade-landing-reviews-section-swiper")) return;
  const { initReviews } = await import(
    /* webpackChunkName: "made-category-reviews" */
    "./reviews/jiffymade-landing-reviews"
  );
  initReviews();
};

export const loadGallery = async () => {
  if (!document.querySelector(".js-jiffymade-landing-gallery")) return;
  const { initGallery } = await import(
    /* webpackChunkName: "made-category-gallery" */
    "./gallery/jiffymade-landing-gallery"
  );
  initGallery();
};

export const loadCarousel = async () => {
  const $userSections = document.querySelector(
    ".js-favorites-swiper, .js-ordered-items-swiper, .js-saved-projects-container"
  );
  if (!$userSections) return;
  await import(
    /* webpackChunkName: "made-category-carousel" */
    "./made-category-product-card/carousel/made-product-card-carousel"
  );
};
